module EEX.McEc.Commands {

    export class CreateAndSavePkcsFileCommand {

        public createAndSave(store: Pki.Store, pkcsPassword: string, certificateFileName : string, success: () => void, error: () => void) {
            try {
                var pkcsFile = store.getPkcs12Format(pkcsPassword, true);
                var dataUri = "data:application/x-pkcs12;base64," + pkcsFile;
                kendo.saveAs({
                    dataURI: dataUri,
                    fileName: certificateFileName
                });
                success();
            } catch (e) {
                error();
            }
        }

        public createAndSaveInPkcsAndCert(store: Pki.Store, certificateFile: string, pkcsPassword: string, privateKeyFileName: string, certificateFileName: string, success: () => void, error: () => void) {
            try {
                let pkcsFile = store.getPkcs12Format(pkcsPassword, false);
                let dataUri = "data:application/x-pkcs12;base64," + pkcsFile;

                let cerData = window.btoa(certificateFile);
                let cerDataUri = "data:application/pkix-cert;base64," + cerData;

                kendo.saveAs({
                    dataURI: dataUri,
                    fileName: privateKeyFileName
                });

                kendo.saveAs({
                    dataURI: cerDataUri,
                    fileName: certificateFileName
                });
                success();
            } catch (e) {
                error();
            }
        }
    }
}